/**
 * Download rows as a CSV file that Excel opens correctly (UTF-8 BOM keeps Arabic readable).
 */
export interface CsvColumn<Row> {
  label: string;
  value: (row: Row) => string | number | null | undefined;
}

const toCell = (value: string | number | null | undefined) => {
  const text = value === null || value === undefined ? '' : String(value);
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export function downloadCsv<Row>(columns: CsvColumn<Row>[], rows: Row[], fileName: string): void {
  const lines = [
    columns.map((c) => toCell(c.label)).join(','),
    ...rows.map((row) => columns.map((c) => toCell(c.value(row))).join(',')),
  ];
  const blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
